import { type AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';

import { ActionKeys } from '~/actions/constants';
import * as transactionsActions from '~/actions/transactions.actions';
import * as transactionsService from '~/services/transactions.service';
import { fromJSON, type JSONTransaction } from '~/types/Transaction';

export function* fetchTransaction(action: ReturnType<typeof transactionsActions.fetchTransaction>) {
  try {
    const result: AxiosResponse<JSONTransaction> = yield call(
      transactionsService.get,
      action.payload.transactionId,
    );
    const parsedTransaction = fromJSON(result.data);
    yield put(transactionsActions.fetchTransactionSuccess(parsedTransaction));
  } catch (err) {
    yield put(transactionsActions.fetchTransactionError());
  }
}

export function* sendEmailNotification(
  action: ReturnType<typeof transactionsActions.sendEmailNotification>,
) {
  try {
    yield call(transactionsService.emailNotify, [action.payload.transactionId]);
    yield put(transactionsActions.sendEmailNotificationSuccess());
  } catch (err) {
    yield put(transactionsActions.sendEmailNotificationError());
  }
}

export default [
  takeEvery(ActionKeys.FETCH_TRANSACTION, fetchTransaction),
  takeEvery(ActionKeys.SEND_EMAIL_NOTIFICATION, sendEmailNotification),
];
